




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingStatus from '@/models/Bookings/BookingStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';


@Component({
  name: 'BookingStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: BookingStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case BookingStatus.Active:
				color = "green--text";
				break;
			case BookingStatus.Cancelled:
				color = "red--text";
				break;
			default:
				color = "grey--text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case BookingStatus.Active:
				text = "ACTIVE";
				break;
			case BookingStatus.Cancelled:
				text = "CANCELLED";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
